import { render, staticRenderFns } from "./EmbedSlideConfig.vue?vue&type=template&id=3652eb91&scoped=true"
import script from "./EmbedSlideConfig.vue?vue&type=script&lang=js"
export * from "./EmbedSlideConfig.vue?vue&type=script&lang=js"
import style0 from "./EmbedSlideConfig.vue?vue&type=style&index=0&id=3652eb91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3652eb91",
  null
  
)

export default component.exports